import { Stack, Text, Switch, Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

type PrivacyPreferenceProps = {
  value: { profilePublic: boolean };
  onChange: (value: { profilePublic: boolean }) => void;
};

export const PrivacyPreference = ({ value, onChange }: PrivacyPreferenceProps) => {
  return (
    <Stack gap="md">
      <Text fw={500}>Profile visibility</Text>

      <Switch
        checked={value.profilePublic}
        onChange={(event) => onChange({ profilePublic: event.currentTarget.checked })}
        label="Make my profile and recipes public"
        description="Allow others to view your cookbook and recipes via a shareable link"
        size="md"
        color="orange"
        styles={{
          root: {
            alignSelf: 'flex-start'
          }
        }}
      />

      <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light" radius="lg">
        {value.profilePublic ? (
          <>
            <Text size="sm" fw={500} mb={4}>Your profile is public</Text>
            <Text size="sm">
              Anyone with a link to your recipes can view them. You can share recipe links directly from your cookbook.
            </Text>
          </>
        ) : (
          <>
            <Text size="sm" fw={500} mb={4}>Your profile is private</Text>
            <Text size="sm">
              Only you can view your recipes and cookbook. Enable public access to share recipes with friends and family.
            </Text>
          </>
        )}
      </Alert>
    </Stack>
  );
};
